import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface HomeFinalCTAProps {
  onCTA: () => void;
}

const HomeFinalCTA = ({ onCTA }: HomeFinalCTAProps) => {
  return (
    <section className="py-32 px-6 bg-[var(--page-bg)]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-[24px] font-semibold text-[var(--text-primary)] mb-6 md:mb-8 tracking-normal">
          Ready to{' '}
          <span className="text-[var(--accent-hex)]">
            get started
          </span>?
        </h2>

        <p className="text-[16px] text-[var(--text-secondary)] mb-10 md:mb-12">
          Join Fortune 500 companies making{' '}
          <span className="text-[var(--accent-hex)] font-medium">
            smarter
          </span>{' '}
          hiring decisions
        </p>

        <Button
          onClick={onCTA}
          size="lg"
          className="h-12 md:h-14 px-8 md:px-10 text-[13px] font-semibold bg-[var(--accent-hex)] hover:bg-[var(--accent-hover)] text-white rounded-lg transition-all duration-200"
        >
          Get Started
          <ArrowRight className="ml-2 h-4 md:h-5 w-4 md:w-5" />
        </Button>

        <p className="text-[11px] text-[var(--text-muted)] mt-6">
          No credit card required • Results in 10 minutes • Trusted by Fortune 500
        </p>
      </div>
    </section>
  );
};

export default HomeFinalCTA;
